import React, { useState } from 'react';
import { LayoutDashboard, Image, Calendar, CalendarCheck, Type, Share2, Users, UserPlus, Banknote } from 'lucide-react';
import EventsSection from './sections/EventsSection';
import HeroSection from './sections/HeroSection';
import GallerySection from './sections/GallerySection';
import FooterSection from './sections/FooterSection';
import AboutSection from './sections/AboutSection';
import MembershipSection from './sections/MembershipSection';
import EventRegistrationsSection from './sections/EventRegistrationsSection';
import TikkieSection from './sections/TikkieSection';

type Section = 'hero' | 'events' | 'gallery' | 'footer' | 'about' | 'membership' | 'event_registrations' | 'tikkie';

const Dashboard = () => {
  const [activeSection, setActiveSection] = useState<Section>('hero');

  const renderSection = () => {
    switch (activeSection) {
      case 'hero':
        return <HeroSection />;
      case 'gallery':
        return <GallerySection />;
      case 'footer':
        return <FooterSection />;
      case 'about':
        return <AboutSection />;
      case 'events':
        return <EventsSection />;
      case 'membership':
        return <MembershipSection />;
      case 'event_registrations':
        return <EventRegistrationsSection />;
      case 'tikkie':
        return <TikkieSection />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col lg:flex-row gap-6">
      <div className="w-full lg:w-64 bg-white shadow rounded-lg p-4">
        <h2 className="text-lg font-medium text-gray-900 mb-4">Secties</h2>
        <nav className="space-y-2">
          <button 
            onClick={() => setActiveSection('hero')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'hero' 
                ? 'bg-[#5A130E] text-white' 
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Type className="w-4 h-4" />
            Hero
          </button>
          <button 
            onClick={() => setActiveSection('about')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'about' 
                ? 'bg-[#5A130E] text-white' 
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Users className="w-4 h-4" />
            Over Ons
          </button>
          <button 
            onClick={() => setActiveSection('events')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'events' 
                ? 'bg-[#5A130E] text-white' 
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Calendar className="w-4 h-4" />
            Agenda
          </button>
          <button 
            onClick={() => setActiveSection('membership')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'membership' 
                ? 'bg-[#5A130E] text-white' 
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <UserPlus className="w-4 h-4" />
            Lidmaatschap
          </button>
          <button 
            onClick={() => setActiveSection('gallery')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'gallery' 
                ? 'bg-[#5A130E] text-white' 
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Image className="w-4 h-4" />
            Galerij
          </button>
          <button
            onClick={() => setActiveSection('footer')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'footer'
                ? 'bg-[#5A130E] text-white'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Share2 className="w-4 h-4" />
            Footer
          </button>
          <div className="border-t border-gray-200 my-3" />
          <button
            onClick={() => setActiveSection('event_registrations')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'event_registrations'
                ? 'bg-[#5A130E] text-white'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <CalendarCheck className="w-4 h-4" />
            Events
          </button>
          <button
            onClick={() => setActiveSection('tikkie')}
            className={`w-full flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md transition-colors ${
              activeSection === 'tikkie'
                ? 'bg-[#5A130E] text-white'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Banknote className="w-4 h-4" />
            Tikkie
          </button>
        </nav>
      </div>
      <div className="flex-1 overflow-x-auto">{renderSection()}</div>
    </div>
  );
};

export default Dashboard;